export interface IProjectCountResponse {
  key?: string;
  value: number;
}

export class ProjectsCount {
  preCast: IProjectCountResponse[] = [];
  nativeSoil: IProjectCountResponse[] = [];
}
